module.exports = __webpack_public_path__ + "img/2.621a3331.jpg";